import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'dtxi_tutorial_mobile_v1';

const PASOS = [
  {
    titulo: '¡Bienvenido a DTXI! ',
    texto: 'Te mostramos dónde encontrar cada cosa. Tardás menos de un minuto.',
    icono: '',
    target: null,
  },
  {
    titulo: 'Este es el menú ☰',
    texto: 'Tocá el ícono de arriba a la derecha para abrir el menú principal.',
    icono: '☰',
    target: 'hamburger',
  },
  {
    titulo: 'Mi Equipo ',
    texto: 'Acá armás tu equipo. En Táctico girás las ruletas para obtener formación y restricciones. En Libre elegís libremente con $75M.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: 'Torneos ',
    texto: 'Unite a torneos con tus amigos o creá el tuyo. Torneo tactico tablero estilo juego de mesa y comodines.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: 'Por los Puntos ',
    texto: 'Desafiá a otros jugadores en duelos 1v1. Cada jornada recibís desafíos automáticos y podés hacer más de forma manual. Subí de división y llegá a DTXI.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: 'Minijuegos ',
    texto: 'Formidable (adiviná el jugador misterioso del fútbol argentino), Penales y otros minijuegos.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: 'Prode & Mundial',
    texto: 'Predecí resultados en el Prode y seguí el fixture y los grupos del Mundial 2026.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: 'Tu perfil ',
    texto: 'En la parte inferior del menú encontrás "MI CUENTA", donde podrás visualizar tu palmarés, reglamento y la configuración de tu contraseña.',
    icono: '',
    target: 'menu',
  },
  {
    titulo: '¡Listo! ',
    texto: 'Ya sabés dónde está todo. ¡Girá las ruletas y armá tu equipo!',
    icono: '',
    target: null,
  },
];

const TutorialMobile = () => {
  const [visible, setVisible] = useState(false);
  const [paso, setPaso] = useState(0);

  useEffect(() => {
    // Solo en mobile
    if (window.innerWidth > 768) return;
    const visto = localStorage.getItem(STORAGE_KEY);
    if (!visto) setVisible(true);
  }, []);

  const cerrar = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const siguiente = () => {
    if (paso < PASOS.length - 1) setPaso(p => p + 1);
    else cerrar();
  };

  if (!visible) return null;

  const pasoActual = PASOS[paso];
  const esIntro = paso === 0;
  const esFin = paso === PASOS.length - 1;
  const progreso = ((paso) / (PASOS.length - 1)) * 100;

  return (
    <>
      {/* Overlay */}
      <div
        onClick={siguiente}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.75)',
          backdropFilter: 'blur(3px)',
          zIndex: 99990,
        }}
      />

      {/* Card del tutorial */}
      <div style={{
        position: 'fixed',
        bottom: 0, left: 0, right: 0,
        zIndex: 99999,
        background: '#0f172a',
        borderTop: '2px solid #00f2ff',
        borderRadius: '20px 20px 0 0',
        padding: '24px 20px 32px',
        boxShadow: '0 -8px 40px rgba(0,242,255,0.15)',
        animation: 'slideUp 0.3s ease',
      }}>
        <style>{`
          @keyframes slideUp {
            from { transform: translateY(100%); opacity: 0; }
            to   { transform: translateY(0);    opacity: 1; }
          }
        `}</style>

        {/* Barra de progreso */}
        <div style={{ height: '3px', background: '#1e293b', borderRadius: '2px', marginBottom: '20px', overflow: 'hidden' }}>
          <div style={{
            height: '100%', width: `${progreso}%`,
            background: 'linear-gradient(90deg, #00f2ff, #a855f7)',
            borderRadius: '2px',
            transition: 'width 0.3s ease',
          }}/>
        </div>

        {/* Ícono + contenido */}
        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '24px' }}>
          <div style={{
            width: '52px', height: '52px', flexShrink: 0,
            background: '#0a1628', border: '1px solid #00f2ff33',
            borderRadius: '14px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.6rem',
          }}>
            {pasoActual.icono}
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{
              color: '#fff', margin: '0 0 6px',
              fontSize: '1rem', fontWeight: '800', lineHeight: 1.2,
            }}>
              {pasoActual.titulo}
            </h3>
            <p style={{
              color: '#94a3b8', margin: 0,
              fontSize: '0.85rem', lineHeight: 1.55,
            }}>
              {pasoActual.texto}
            </p>
          </div>
        </div>

        {/* Dots de progreso */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '18px' }}>
          {PASOS.map((_, i) => (
            <div key={i} style={{
              width: i === paso ? '18px' : '6px',
              height: '6px',
              borderRadius: '3px',
              background: i === paso ? '#00f2ff' : i < paso ? '#a855f7' : '#1e293b',
              transition: 'all 0.3s ease',
            }}/>
          ))}
        </div>

        {/* Botones */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={cerrar}
            style={{
              flex: 1, padding: '12px',
              background: 'transparent',
              border: '1px solid #1e293b',
              borderRadius: '10px',
              color: '#475569', fontSize: '0.82rem',
              cursor: 'pointer', fontWeight: 'bold',
            }}
          >
            Saltar
          </button>
          <button
            onClick={siguiente}
            style={{
              flex: 2, padding: '12px',
              background: esFin
                ? 'linear-gradient(135deg, #22c55e, #16a34a)'
                : 'linear-gradient(135deg, #00f2ff, #0891b2)',
              border: 'none',
              borderRadius: '10px',
              color: '#000', fontSize: '0.9rem',
              cursor: 'pointer', fontWeight: '900',
              boxShadow: esFin
                ? '0 4px 20px rgba(34,197,94,0.35)'
                : '0 4px 20px rgba(0,242,255,0.35)',
            }}
          >
            {esFin ? '¡Empezar! 🚀' : `Siguiente (${paso + 1}/${PASOS.length - 1})`}
          </button>
        </div>
      </div>

      {/* Flecha apuntando a la hamburguesa — solo en paso 1 */}
      {paso === 1 && (
        <div style={{
          position: 'fixed',
          top: '8px', right: '52px',
          zIndex: 99999,
          animation: 'bounce 1s ease infinite',
          fontSize: '1.8rem',
          filter: 'drop-shadow(0 0 8px #00f2ff)',
        }}>
          ↗️
        </div>
      )}
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
      `}</style>
    </>
  );
};

export default TutorialMobile;